

import Accounts from "./Accounts";


class Metric extends Accounts{
    constructor(params) {
        super(params);
    
    this.accountLabel = "Metric";
    this.accountType = "Metric";
    this.account = "Metric";
  
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }
   
    setDomain(val){
       this.generic.subTitle = val;
        this.domain = val;
      if (val && val != ''){
      var pts = val.split(".");
          pts.pop();
      this.generic.url = "https://" + pts.pop() + ".simpliad.com";
      }
    }

    setDefaultSettings(json){
        this.defaultSettings = json;
    }

    setFilters(json){
        this.filters = json;
    }
    setFormula(json){
        this.formula = json;
    }

    setDefinition(json){
        this.definition = json;
    }
    setDescription(str){
        this.description = str;
        this.generic.description = str;
    }
    setLabel(str){
        this.label = str;
        this.generic.name = str;
    }
    setFormat(str){
        this.format = str;
        this.generic.subTitle = str;
    }

        

    setConfiguration(json){
        this.networkConnections = (json.connections) ? json.connections : this.networkConnections;
        this.configuration = (json.settings) ? json.settings : this.configuration;
    }
}

export default Metric;
  